<template>
    <div>
        <payment-screen
            v-if="stripeMounted"
            class="max-w-sm mx-auto"
            @registered="handleSuccessfulRegistration"
            :show-order-summary="true"
            :enable-coupon-field="true"/>
        <trust-pilot-review step="cardDetails"/>
        <div class="clear--sm"></div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { USER_TYPE } from '@/constants/Account';
import { SECTION_ACCOUNT } from '@/constants/Registration';
import AuthService from '@/services/auth/AuthService';
import TrustPilotReview from '@/components/forms/fields/TrustPilotReview';
import PaymentScreen from '@/components/forms/register/PaymentScreen';

let authService = new AuthService();

export default {
    name: 'CardDetails',
    methods: {
        ...mapActions({
            fetchIncompleteRegistrationData: 'register/fetchIncompleteRegistrationData',
        }),
        async handleSuccessfulRegistration() {
            if (this.$globalQueryParams.uuid) {
                return this.$router.push({ name: 'login' });
            }
            let email = this.$store.getters['register/getEmail'];
            let password = this.$store.getters['register/getPassword'];

            const response = await authService.login(email, password);
            localStorage.setItem('access_token', response.data.tokens.access_token);
            localStorage.setItem('refresh_token', response.data.tokens.refresh_token);

            this.$store.commit('register/resetState');
            this.$globalQueryParams.uuid = null;
            this.$store.dispatch('auth/loginUser', USER_TYPE);

            this.$router.push({ name: 'account.confirmation' });
        },
    },
    components: {
        PaymentScreen,
        TrustPilotReview,
    },
    computed: {
        stripeMounted() {
            return this.$store.getters['cookies/isStripeMounted'];
        },
    },
    mounted() {
        if (!this.$store.getters['register/getSectionCompleted'](SECTION_ACCOUNT) && !this.$globalQueryParams.uuid) {
            this.$router.push({ name: 'register.account' });
        }
        let uuid = this.$globalQueryParams.uuid;
        uuid && this.fetchIncompleteRegistrationData(this.$globalQueryParams.uuid);
        this.$scrollTo('#app');
    },
};
</script>
